import "./Contactanos.css";
import { FaWhatsapp, FaInstagram, FaFacebook, FaPhone, FaMapMarkerAlt, FaEnvelope } from "react-icons/fa";
import { useState } from "react";

function Contactanos() {
  const [form, setForm] = useState({
    nombre: "",
    email: "",
    Nro_Contacto: "",
    mensaje: "",
  });

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const enviar = async () => {
    if (!form.nombre || !form.email || !form.mensaje) {
      alert("Por favor completa todos los campos obligatorios");
      return;
    }

    try {
      const res = await fetch(
        "https://sindicato.sintrasecsalud.com/api/index.php?modulo=contacto&accion=enviar",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(form),
        }
      );

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch (e) {
        alert("El backend no está devolviendo JSON válido");
        return;
      }

      if (data.success) {
        alert("Mensaje enviado correctamente");
        setForm({ nombre: "", email: "", Nro_Contacto: "", mensaje: "" });
      } else {
        alert(data.message || "Error al enviar");
      }
    } catch (error) {
      console.error(error);
      alert("Error de conexión");
    }
  };

  return (
    <div className="contact-container">
      {/* HERO */}
      <div className="contact-hero">
        <h1>Contáctanos</h1>
        <p>Estamos aquí para ayudarte y escucharte</p>
      </div>

      {/* LAYOUT PRINCIPAL */}
      <div className="contact-main">
        {/* COLUMNA IZQUIERDA */}
        <div className="contact-info">
          {/* Información de contacto */}
          <div className="info-card">
            <h2>📍 Información</h2>
            <div className="info-list">
              <div className="info-item">
                <div className="info-icon">
                  <FaMapMarkerAlt />
                </div>
                <div className="info-content">
                  <h3>Dirección</h3>
                  <p>Cra. 44 - No. 9C-58, Cali, Valle del Cauca</p>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaPhone />
                </div>
                <div className="info-content">
                  <h3>Teléfono</h3>
                  <a href="tel:+573206769169">+57 320 6769169</a>
                </div>
              </div>

              <div className="info-item">
                <div className="info-icon">
                  <FaEnvelope />
                </div>
                <div className="info-content">
                  <h3>Email</h3>
                  <a href="mailto:sintrasecsalud@gmail.com">sintrasecsalud@gmail.com</a>
                </div>
              </div>
            </div>

            <a
              href="https://maps.app.goo.gl/21kb1Ym9JByiJvHF7"
              target="_blank"
              rel="noreferrer"
              className="map-btn"
            >
              <FaMapMarkerAlt /> Ver en Google Maps
            </a>
          </div>

          {/* Redes sociales */}
          <div className="socials-card">
            <h3>Síguenos en redes</h3>
            <div className="socials">
              <a
                href="https://wa.me/573206769169"
                target="_blank"
                rel="noreferrer"
                className="social-icon whatsapp"
                aria-label="WhatsApp"
              >
                <FaWhatsapp />
              </a>
              <a
                href="https://instagram.com/"
                target="_blank"
                rel="noreferrer"
                className="social-icon instagram"
                aria-label="Instagram"
              >
                <FaInstagram />
              </a>
              <a
                href="https://facebook.com/"
                target="_blank"
                rel="noreferrer"
                className="social-icon facebook"
                aria-label="Facebook"
              >
                <FaFacebook />
              </a>
            </div>
          </div>
        </div>

        {/* COLUMNA DERECHA - Formulario */}
        <div className="contact-form-wrapper">
          <h2>✉️ Escríbenos</h2>
          <div className="form-grid">
            <div className="form-group">
              <input
                type="text"
                name="nombre"
                value={form.nombre}
                onChange={handleChange}
                placeholder="Nombre completo"
                required
              />
            </div>

            <div className="form-group">
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Correo electrónico"
                required
              />
            </div>

            <div className="form-group full-width">
              <input
                type="tel"
                name="Nro_Contacto"
                value={form.Nro_Contacto}
                onChange={handleChange}
                placeholder="Número de contacto"
              />
            </div>

            <div className="form-group full-width">
              <textarea
                name="mensaje"
                value={form.mensaje}
                onChange={handleChange}
                placeholder="Tu mensaje..."
                rows="5"
                required
              />
            </div>

            <div className="form-group full-width">
              <button className="submit-btn" onClick={enviar}>
                Enviar mensaje
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contactanos;